import Api from '@/services/Api';
import Perfil from '@/model/Perfil';

const RECURSO = '/perfis';
export default {
    newPerfil,
    getAllPerfil,
    getPerfil,
    postPerfil,
    postPerfilRetornar,
    putPerfil,
    deletePerfil,
};

function newPerfil(id=0,nome='',listPrivilegios=[]){
    return new Perfil(id,nome,listPrivilegios);
}

function getAllPerfil () {
    return Api.get(`${RECURSO}`);
}

function getPerfil (id) {
    return Api.get(`${RECURSO}/${id}`);
}

function postPerfil(payload){
    return Api.post(`${RECURSO}`, payload);
}

function postPerfilRetornar(payload){
    return Api.post(`${RECURSO}/retornar`, payload);
}

function putPerfil(payload){
    return Api.put(`${RECURSO}/${payload.id}`, payload);
}

function deletePerfil(id){
    return Api.delete(`${RECURSO}/${id}`);
}
